import type { ReactElement } from "react";
import { Icon } from "@chakra-ui/react";
import type { IconProps } from "@chakra-ui/react";

const LinkedinLogo = ({
  color = "#0A66C2",
  ...props
}: IconProps): ReactElement => (
  <Icon viewBox="0 0 128 128" color={color} {...props}>
    <title>LinkedIn Logo</title>
    <path
      fill="currentColor"
      d="M64 128c35.346 0 64-28.654 64-64 0-35.346-28.654-64-64-64C28.654 0 0 28.654 0 64c0 35.346 28.654 64 64 64z"
    />
    <path
      fill="#fff"
      d="M29.075 51.75h14.868v47.79H29.075V51.75zM36.513 28a8.612 8.612 0 11-.01 17.225A8.612 8.612 0 0136.513 28zM53.25 51.75H67.5v6.535h.205c1.98-3.75 6.828-7.72 14.052-7.72 15.04 0 17.818 9.897 17.818 22.767V99.54h-14.85V76.29c0-5.543-.095-12.673-7.718-12.673-7.727 0-8.907 6.04-8.907 12.275V99.53H53.25V51.75z"
    />
  </Icon>
);

export default LinkedinLogo;
